import VideoPlayer from '@/components/VideoPlayer';

interface StepTipsPanelProps {
  /** Rich-text tips managed by admin at /admin/company-profile-steps */
  tips?: string;
  videoLink?: string;
  /** Some pages use a darker panel background than the default */
  darkBackground?: boolean;
  className?: string;
}

/**
 * Shared "Tips Pengisian" side panel for company profile steps.
 *
 * All body content comes from the company-profile-steps API (`tips`), which
 * admins manage from the Tips & Panduan section of the admin panel. Nothing
 * here is hardcoded — if a step has no tips yet, only the heading is rendered.
 */
export default function StepTipsPanel({ tips, videoLink, darkBackground, className }: Readonly<StepTipsPanelProps>) {
  const background = darkBackground ? 'dark:bg-[#1A1A1A]' : 'dark:bg-gray-800';

  return (
    <div
      className={`bg-blue-50 ${background} border border-blue-100 dark:border-gray-700 rounded-xl p-5 space-y-4 xl:sticky xl:top-4 xl:max-h-[calc(100vh-8rem)] xl:overflow-y-auto min-w-0 ${
        className ?? ''
      }`}
    >
      <div className="flex items-center gap-2">
        <span className="text-xl">💡</span>
        <h3 className="font-bold text-base" style={{ color: '#1848FD' }}>
          Tips Pengisian
        </h3>
      </div>

      {tips && (
        <div className="overflow-x-auto">
          <div
            className="text-sm text-gray-600 dark:text-gray-300 prose prose-sm dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      )}

      {videoLink && (
        <div className="pt-3 border-t border-blue-200 dark:border-gray-700">
          <VideoPlayer
            url={videoLink}
            tipsHtml={tips}
            className="dark:bg-gray-800 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
          />
        </div>
      )}
    </div>
  );
}
